var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',_vm._g(_vm._b({staticClass:"ibow2-expansion-list",model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}},'v-expansion-panels',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }